var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafetyConcerns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.46 21.346C8.44929 20.4127 5.92666 18.3324 4.43721 15.5545C2.94777 12.7765 2.61111 9.52411 3.5 6.5C6.61553 6.64257 9.66417 5.56658 12 3.5C14.3358 5.56658 17.3845 6.64257 20.5 6.5C21.1787 8.80911 21.1473 11.2689 20.41 13.56M15 19.5L17 21.5L21 17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyConcerns);
export default __webpack_public_path__ + "static/media/safety_concerns.688ec9a68cc7bd000993931cf9855686.svg";
export { ForwardRef as ReactComponent };